<script setup lang="ts">
const items = [
  {
    title: 'Buat & Kelola Pengiriman dari HP',
    description:
      'Kirim barang ke seluruh Indonesia tanpa harus buka laptop, cukup dengan hp Anda di satu aplikasi.',
    icon: 'material-symbols:phone-iphone-outline'
  },
  {
    title: 'Klaim Asuransi & Retur',
    description:
      'Laporkan paket hilang atau rusak, unggah bukti, dan pantau progres klaim secara real-time.',
    icon: 'material-symbols:featured-play-list-outline'
  },
  {
    title: 'Cek Ongkir & Cek Resi Otomatis',
    description:
      'Bandingkan multi tarif ekspedisi dan pantau status pengiriman secara real-time.',
    icon: 'material-symbols:search'
  },
  {
    title: 'Kirim Paket Massal Multi Produk',
    description:
      'Proses ratusan order dengan satu proses otomatis. Hemat waktu, dan minim kesalahan input. Cocok untuk pengiriman skala besar.',
    icon: 'material-symbols:quick-reorder-outline'
  },
  {
    title: 'COD Cair Cepat',
    description:
      'Cairkan Hingga 50% Dana COD Sebelum Paket Diterima. Ideal untuk bisnis dengan volume pengiriman tinggi.',
    icon: 'material-symbols:percent'
  },
  {
    title: 'Keyboard KiriminAja',
    description:
      'Gunakan KiriminAja Keyboard untuk cek ongkir, buat paket, dan kirim link pembayaran COD langsung dari aplikasi chat.',
    icon: 'material-symbols:keyboard-alt-outline'
  },
  {
    title: 'Whatsapp Follow-up',
    description:
      'Kirim notifikasi status kiriman ke pembeli secara otomatis melalui WhatsApp dari pickup, transit, hingga delivered.',
    icon: 'ic:baseline-whatsapp'
  },
  {
    title: 'KiriminAja Poin',
    description:
      'Setiap pengiriman menambah poin yang bisa ditukar berbagai hadiah menarik.',
    icon: 'ka-icon:ka-poin'
  },
  {
    title: 'Undelivery Notification',
    description:
      'Dapatkan peringatan real-time jika terjadi kendala di lapangan seperti alamat tidak valid, penerima tidak ada, atau kurir gagal antar.',
    icon: 'material-symbols:notifications-outline'
  },
  {
    title: 'Laporan & Notifikasi',
    description:
      'Pantau performa pengiriman dan histori transaksi secara otomatis dari HP Anda.',
    icon: 'material-symbols:assignment-outline'
  }
]

const { isMobile } = useBreakpoints()
</script>

<template>
  <UiContainer class="py-12 flex flex-col gap-12">
    <UiSectionTitle title="Manfaat Utama untuk Bisnis Anda" title-as="h2" />
    <div class="grid gap-6 grid-cols-1 md:grid-cols-2">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="flex items-start gap-3"
      >
        <div
          class="p-2 rounded-full bg-primary-container flex-none text-primary"
        >
          <Icon :name="item.icon" :size="isMobile ? '22px' : '30px'" />
        </div>
        <div class="flex-1 flex flex-col gap-2">
          <p class="text-sm lg:text-xl font-bold lg:font-semibold">
            {{ item.title }}
          </p>
          <p class="text-sm lg:text-base text-outline">
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
  </UiContainer>
</template>
